import React, { FunctionComponent, Fragment, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { Alert as AlertModel, removeAlertThunk } from '@spike/notifications-action';
import Alert from './Alert';
import styles from './Notifications.module.scss';

export const Notifications: FunctionComponent = () => {
    const dispatch = useDispatch();
    const alerts = useSelector<RootState, Array<AlertModel>>(state => state.notifications.alerts);

    useEffect(() => {
        // Auto-dismiss alerts after 5 seconds
        const timers = alerts.map(alert =>
            setTimeout(() => {
                dispatch(removeAlertThunk(alert.key));
            }, 5000)
        );

        return () => {
            timers.forEach(timer => clearTimeout(timer));
        };
    }, [alerts, dispatch]);

    const notificationsContent = (
        <Fragment>
            {alerts.length > 0 && (
                <div className={styles.container}>
                    {alerts.map(alert => (
                        <Alert
                            key={alert.key}
                            alert={alert}
                        />
                    ))}
                </div>
            )}
        </Fragment>
    );

    // Render notifications in portal to ensure they appear above modals
    return createPortal(notificationsContent, document.body);
};

export default Notifications;
